document.addEventListener('DOMContentLoaded', function() {

  /* Bloquear scroll al abrir drawer sin salto */
  var scrollY = 0;

  $(document.body).on('drawer.open', function() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  });

  $(document.body).on('drawer.close', function() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, scrollY);
  });

});